module.exports = __webpack_public_path__ + "linea-music-10.6db7e51310cba57aeb54.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/linea-icons/fonts/linea-music-10.svg
// module id = ../../../../../src/scss/icons/linea-icons/fonts/linea-music-10.svg
// module chunks = styles